import { Flex, Space, Typography } from "antd"

export const CheckoutsEditStepUi = () => {
  return (
    <Flex vertical>
      <Typography.Text>
        After creating a Checkout, click on its name to copy the HTML code.
        <br />
        <br />
        You can embed this code on your website as a Payment Button—when
        clicked, it will open the payment page in an iFrame for a seamless
        checkout experience.
      </Typography.Text>
    </Flex>
  )
}
